import type { ThemeBorders } from '@deity/falcon-ui';
import { FlexLayout, H4 } from '@deity/falcon-ui';
import type { FC, ReactElement } from 'react';

interface FooterItemProps {
  bl?: keyof ThemeBorders;
  br?: keyof ThemeBorders;
  itemTitle: string;
  children: ReactElement;
}
export const FooterItem: FC<FooterItemProps> = ({ bl, br, itemTitle, children }) => (
  <FlexLayout
    pl="lg"
    pr="lg"
    borderLeft={bl}
    borderRight={br}
    borderColor="border"
    height="full"
    flexDirection="column"
    alignItems="center"
  >
    <H4 color="secondary" fontWeight="semiBold" fontSize="sm">
      {itemTitle}
    </H4>
    {children}
  </FlexLayout>
);
